import Button, { type ButtonProps } from "@mui/material/Button";
import { styled } from "@mui/material/styles";

interface StyledButtonProps extends ButtonProps {
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  textColor?: string;
  hoverTextColor?: string;
}

const DEFAULT_BACKGROUND_COLOR = "var(--color-primary)";
const DEFAULT_TEXT_COLOR = "var(--color-text-inverse)";
const DEFAULT_HOVER_BACKGROUND_COLOR = "var(--color-secondary)";
const DEFAULT_HOVER_TEXT_COLOR = "var(--color-text-inverse)";

export const CustomButton = styled(Button, {
  shouldForwardProp: (prop) =>
    !["backgroundColor", "hoverBackgroundColor", "textColor", "hoverTextColor", "onFileChange"].includes(prop as string),
})<StyledButtonProps>(({ backgroundColor, hoverBackgroundColor, textColor, hoverTextColor }) => ({
  fontWeight: "var(--font-weight-bold)",
  paddingLeft: "var(--space-3_5xl)",
  paddingRight: "var(--space-3_5xl)",
  borderRadius: "var(--radius-xsm)",
  textTransform: "none",
  fontSize: "var(--font-size-lg)",

  backgroundColor: backgroundColor ?? DEFAULT_BACKGROUND_COLOR,
  color: textColor ?? DEFAULT_TEXT_COLOR,

  transition: "0.6s ease-out",

  "&:hover": {
    backgroundColor: hoverBackgroundColor ?? DEFAULT_HOVER_BACKGROUND_COLOR,
    color: hoverTextColor ?? DEFAULT_HOVER_TEXT_COLOR,
  },
}));

export const FileInput = styled("input")(() => ({
  display: "none",
}));
